var general_form = {
    form_object: null,
    url: null,
    run: function () {

        var url = this.url;
        var form = $(this.form_object);
        var submit_button = $(form).find(":submit");
        var data = form.serializeArray();

        var csrf_token = getCookie('CSRF-TOKEN');
        var csrf_token_key = getCookie('CSRF-TOKEN-KEY');

        var p_message = $(form).find("p.message");

        p_message.hide();
        submit_button.attr('disabled', 'disabled');

        p_message.removeClass('text-danger');
        p_message.removeClass('text-success');

        data.push({name: csrf_token_key, value: csrf_token});
        data.push({name: "from_uri", value: location.pathname});

        $.ajax({
            url: url,
            type: 'post',
            data: data,
            success: function (data) {

                if (data.status == 'SUCCESS') {

                    if (data.href === undefined || data.href === null) {
                        p_message.addClass('text-success');
                        p_message.text(data.message);
                        p_message.show();
                        submit_button.removeAttr("disabled");
                        return true;
                    }
                    $(location).attr('href', data.href);
                    return true;
                } else {
                    p_message.addClass('text-danger');
                    p_message.text(data.message);
                    p_message.show();
                    submit_button.removeAttr("disabled");
                    return true;
                }

            },
            error: function (xhr, ajaxOptions, thrownError) {
                p_message.text("Unknown error");
                p_message.show();
                submit_button.removeAttr("disabled");
                return false;
            }
        });


        return false;

    }
}

$(document).on('submit', 'form#ForgotPasswordModalForm', function (e) {
    e.preventDefault();
    if (typeof(window.sessionStorage) !== "undefined") {
        var country_code = $(this).find("select[name=country_code]").val();
        sessionStorage.setItem("registration_data", JSON.stringify({
            country_code: country_code
        }));
    }

    var form = general_form;
    form.url = '/session/forgotpassword/';
    form.form_object = this;
    form.run();
});

$(document).on('submit', 'form#loginModalForm', function (e) {
    e.preventDefault();

    var form = general_form;
    form.url = '/session/login/';
    form.form_object = this;
    form.run();
});

$(document).on('submit', 'form#RegisterModalForm', function (e) {
    e.preventDefault();
    var form = general_form;
    form.url = '/session/register/';
    form.form_object = this;
    form.run();
});

$(document).on('submit', 'form#registerForm', function (e) {

    if (typeof(window.sessionStorage) !== "undefined") {
        var email_or_phone = $(this).find("input[name=phone_number]").val();
        var country_code = $(this).find("select[name=country_code]").val();

        sessionStorage.setItem("registration_data", JSON.stringify({
            country_code: country_code,
            full_name: $(this).find("input[name=full_name]").val(),
            email_or_phone: email_or_phone,
            age: $(this).find("input[name=18years]").val()
        }));
    }
});

$(document).on('submit', 'form#LoginForm', function (e) {
    if (typeof(window.sessionStorage) !== "undefined") {
        var email_or_phone = $(this).find("input[name=phone_number]").val();
        var country_code = $(this).find("select[name=country_code]").val();

        sessionStorage.setItem("registration_data", JSON.stringify({
            email_or_phone: email_or_phone,
            country_code: country_code
        }));
    }
});

$(document).on('click', '.modal a.switchto_register', function (e) {
    e.preventDefault();
    $('#RegisterModal').modal('show');
    $('#loginModal').modal('hide');
    $('#ForgotPasswordModal').modal('hide');
    return false;
});

$(document).on('click', '.modal a.switchto_login', function (e) {
    e.preventDefault();
    $('#loginModal').modal('show');
    $('#RegisterModal').modal('hide');
    $('#ForgotPasswordModal').modal('hide');
    return false;
});

$(document).on('click', '.modal a.switchto_forgotpassword', function (e) {
    e.preventDefault();
    $('#ForgotPasswordModal').modal('show');
    $('#RegisterModal').modal('hide');
    $('#loginModal').modal('hide');
    return false;
});


$(document).on('click', '.modal a.switchto_deposit', function (e) {
    e.preventDefault();
    $('#depositModal').modal('show');
    return false;
});

$(document).on('click', '.copy-crypto', function () {

    var range = document.createRange();
    range.selectNode(document.getElementById("crypto_code"));
    window.getSelection().addRange(range);
    document.execCommand("Copy");
});


$(document).on('click', '.value-control', function () {

    var action = $(this).attr('data-action');
    var target = $(this).attr('data-target');
    var item = $(this).attr('data-item');
    var value = parseFloat($('[id="' + target + '"]').val());
    if (action == "plus") {
        value++;
    }
    if (action == "minus") {
        value--;
    }
    if (value <= 1) value = 1;

    var price = $("#price-value-" + item).val() * value;

    $("#price-" + item).text(price.toFixed(7));

    $('[id="' + target + '"]').val(value)
});


$(document).on('click', '.value-control-draw', function () {

    var action = $(this).attr('data-action');
    var target = $(this).attr('data-target');
    var value = parseFloat($('[id="' + target + '"]').val());
    if (action == "plus") {
        value++;
    }
    if (action == "minus") {
        value--;
    }
    if (value <= 1) value = 1;

    $('[id="' + target + '"]').val(value)

});

$(document).on('click', 'button.quickpick-add-syndication', function (e) {
    e.preventDefault();
    var product_id = $(this).attr('data-product-id');
    var draws = 1;
    var parent = $(this).closest("div.syndi-lot-box");
    var entries = $(this).find("input[name=shares]").val(); //;
    var data = {"product_id": product_id, "draws": draws, "enteries": entries};

    $.ajax({
        url: "/syndication/add",
        type: 'post',
        data: JSON.stringify(data),
        dataType: "json",
        success: function (data) {
            p_message = $(parent).find("div.quick-add-message");

            if (data.status == 'SUCCESS') {
                if (data.href === undefined || data.href === null) {
                    p_message.addClass('bg-success');
                    p_message.text(data.message);
                    p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                    LotteryObject.mycart_items();
                    return true;
                }
                return true;
            } else {
                p_message.addClass('bg-danger');
                p_message.text(data.message);
                p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                return true;
            }

        },
        error: function (xhr, ajaxOptions, thrownError) {
            p_message.addClass('bg-danger');
            p_message.text("Unknown error");
            p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
            return true;
        }
    });
    return false;
});

$(document).on('click', '.deposit-funds', function () {

    $.ajax({
        url: "/deposit",
        type: 'post',
        dataType: "json",
        success: function (data) {
            p_message.hide();
            p_message = $("p#main_global_message");

            if (data.status == 'SUCCESS') {
                if (data.href === undefined || data.href === null) {
                    p_message.text(data.message);
                    p_message.show();
                    return true;
                }
                $(location).attr('href', data.href);
                return true;
            }

            else if (data.status == 'INSUFFICIENTFUNDS') {
                if (data.href === undefined || data.href === null) {
                    p_message.text(data.message);
                    p_message.show();
                    return true;
                }

                $(location).attr('href', data.href);
                return true;
            }
            else if (data.status == 'NOLOGIN') {
                $('#loginModal').modal('show');
                //p_message.text(data.message);
                //p_message.show();


            } else {
                p_message.text(data.message);
                p_message.show();
            }


            return false;
        },
        error: function (xhr, ajaxOptions, thrownError) {
            p_message.text("Unknown error");
            p_message.show();
            return false;
        }
    });
    return false;

});


$(document).on('click', '.withdraw-funds', function () {
    $.ajax({
        url: "/withdrawal",
        type: 'post',
        dataType: "json",
        success: function (data) {
            p_message.hide();
            p_message = $("p#main_global_message");
            if (data.status == 'SUCCESS') {
                if (data.href === undefined || data.href === null) {
                    p_message.text(data.message);
                    p_message.show();
                    return true;
                }
                $(location).attr('href', data.href);
                return true;
            }

            else if (data.status == 'NOLOGIN') {
                $('#loginModal').modal('show');
                //p_message.text(data.message);
                //p_message.show();

            } else {
                p_message.text(data.message);
                p_message.show();
            }


            return false;
        },
        error: function (xhr, ajaxOptions, thrownError) {
            p_message.text("Unknown error");
            p_message.show();
            return false;
        }
    });
    return false;

});


$(document).on('click', '.game-option-change', function () {

    var target = $(this).attr('data-target');
    var product_id = $(this).attr('data-product');

    //default all products back to null
    $(".scratch-card-add").data("product", null);

    //set selected product
    $('#' + product_id).data("product", target);
});

$(document).on('click', '.quickpick-add', function () {
    var target = $(this).attr('data-target');

    var draws = $('#quick-add-draws-' + target).val();
    var entries = $('#quick-add-entries-' + target).val();
    var data = {"product_id": target, "draws": draws, "enteries": entries}

    $.ajax({
        url: "/play/add",
        type: 'post',
        data: JSON.stringify(data),
        dataType: "json",
        success: function (data) {
            p_message = $("#quick-add-message-" + target);

            if (data.status == 'SUCCESS') {
                if (data.href === undefined || data.href === null) {
                    p_message.addClass('bg-success');
                    p_message.text(data.message);
                    p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                    LotteryObject.mycart_items();
                    return true;
                }
                return true;
            } else {
                p_message.addClass('bg-danger');
                p_message.text(data.message);
                p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                return true;
            }

        },
        error: function (xhr, ajaxOptions, thrownError) {
            p_message.addClass('bg-danger');
            p_message.text("Unknown error");
            p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
            return true;
        }
    });
    return false;
});


$(document).on('click', '.scratch-card-add', function () {
    var product_id = $(this).data('product');
    var data = {"product_id": product_id};
    p_message = $("#quick-add-message-" + this.id);

    //if no product selected
    if (product_id < 1) {
        p_message.addClass('bg-danger');
        p_message.text('please select an option');
        p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
        return true;
    }

    $.ajax({
        url: "/scratch/scratchcard",
        type: 'post',
        data: JSON.stringify(data),
        dataType: "json",
        success: function (data) {

            if (data.status == 'SUCCESS') {
                if (data.href === undefined || data.href === null) {
                    p_message.addClass('bg-success');
                    p_message.removeClass('bg-danger');
                    p_message.text(data.message);
                    p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                    LotteryObject.mycart_items();
                    return true;
                }
                return true;
            } else {
                p_message.addClass('message-danger');
                p_message.text(data.message);
                p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
                return true;
            }

        },
        error: function (xhr, ajaxOptions, thrownError) {
            p_message.addClass('bg-danger');
            p_message.text("Unknown error");
            p_message.slideDown(300).fadeIn(400).delay(3000).fadeOut(400);
            return true;
        }
    });
    return false;
});

var LotteryObject = {
    mycart_items: function () {
        $.ajax({
            url: "/cart/items",
            type: 'get',
            dataType: "json",
            success: function (data) {
                p_message = $("a#mycart_items");

                if (data.status == 'SUCCESS') {
                    if (data.href === undefined || data.href === null) {
                        p_message.text(data.message);
                        return true;
                    }
                    return true;
                }
                return false;
            },
            error: function (xhr, ajaxOptions, thrownError) {
                return false;
            }
        });
        return false;
    },
    checkout: function () {

        var data = $("form#checkout_form").serializeArray();

        $.ajax({
            url: "/checkout",
            type: 'post',
            dataType: "json",
            data: JSON.stringify(data),
            success: function (data) {
                p_message.hide();
                p_message = $("p#main_global_message");

                if (data.status == 'SUCCESS') {
                    if (data.href === undefined || data.href === null) {
                        p_message.text(data.message);
                        p_message.show();
                        return true;
                    }
                    $(location).attr('href', data.href);
                    return true;
                }

                else if (data.status == 'INSUFFICIENTFUNDS') {
                    if (data.href === undefined || data.href === null) {
                        p_message.text(data.message);
                        p_message.show();
                        return true;
                    }

                    $(location).attr('href', data.href);
                    return true;
                }
                else if (data.status == 'NOLOGIN') {
                    $('#loginModal').modal('show');
                    //p_message.text(data.message);
                    //p_message.show();


                } else {
                    p_message.text(data.message);
                    p_message.show();
                }


                return false;
            },
            error: function (xhr, ajaxOptions, thrownError) {
                p_message.text("Unknown error");
                p_message.show();
                return false;
            }
        });
        return false;
    }
}


var change_currency = (function (currency) {
    //event.preventDefault() ;
    var path = location.pathname + "?currency=" + currency;
    window.location = location.pathname + "?currency=" + currency;
});

$(document).ready(function () {
    LotteryObject.mycart_items();

    $(this).on('submit', 'form#checkout_form', function (e) {
        e.preventDefault();
        LotteryObject.checkout();
    });

    // Set the date we're counting down to
    //var countDownDate = new Date().getTime();
    var now = $("#jackpot_countdown").attr('data-now');
    var cuttoff = $("#jackpot_countdown").attr('data-cuttoff');

    var countDownDate = new Date(cuttoff).getTime();


    //Update the count down every 1 second
    var x = setInterval(function () {

        // Get todays date and time
        var now = new Date().getTime();
        //var now = new Date($("#jackpot_countdown").attr('data-now') ).getTime();;

        // Find the distance between now an the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if ($("#jackpot_countdown").length) {
            document.getElementById("jackpot_countdown").innerHTML =
                "<ul class='time_col row'>" +
                "<li class='col'>" +
                "<span>" + days + "</span>" +
                "<span>Days</span>" +
                "</li>" +
                "<li class='col'>" +
                "<span>" + hours + "</span>" +
                "<span>Hours</span>" +
                "</li>" +
                "<li class='col'>" +
                "<span>" + minutes + "</span>" +
                "<span>Min</span>" +
                "</li>" +
                "<li class='col'>" +
                "<span>" + seconds + "</span>" +
                "<span>Sec</span>" +
                "</li>" +
                "</ul>";


            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                document.getElementById("jackpot_countdown").innerHTML = "EXPIRED";
            }
        }


    }, 1000);

});

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var baseResponse = (function (response, target) {
    target.success = false;
    target.hasError = false;

    if (response.body.status == 'SUCCESS') {
        target.success = true;
        target.hasError = false;
    }
    else {
        target.success = false;
        target.hasError = true;
    }
    target.message = response.body.message;
    target.show_message = true;
});
